import {Tabs} from 'antd';
import {TaskTable} from './TaskTable';
import {NewTask} from "./NewTask";
import {checkPerm} from '../../auth/sessionTools'
import {useSearchParams} from "react-router";
import {useEffect, useCallback} from 'react';


export const TaskTab = ({session, refresh, onRefresh, onApiFail, props}) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const tabKey = searchParams.get("tabKey");
    const defaultKey = tabKey ? tabKey: 'AssignedTasks'

    // we need to use a global key list at the top level because there doesn't seem to be an easy way
    // to build the object
    const getCurrentParams = useCallback(() => {
        const searchKeys = ["tabKey", "title", "assignee", "department", "sortColumn", "sortOrder", "status", "due"];
        const nextObj = {};
        searchKeys.forEach(k => {
            const curVal = searchParams.get(k);
            if (curVal) {
                nextObj[k] = curVal;
            }
        });
        return nextObj;
    }, [searchParams]);

    useEffect(() => {
        const tabKey = searchParams.get("tabKey");
        if (tabKey === null) {
            const nextObj = getCurrentParams();
            nextObj["tabKey"] = defaultKey;
            setSearchParams(nextObj);
        }
    }, [defaultKey, searchParams, setSearchParams, getCurrentParams]);

    const onSearchParamsChange = (newValues) => {
        let nextParam = getCurrentParams();
        for (const [key, value] of Object.entries(newValues)) {
            nextParam[key] = value;
        }
        setSearchParams(nextParam);
    }

    const items = [
        {
            key: 'MyTasks',
            label: 'Created by Me',
            children: <TaskTable session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} showVerified={true} taskType={"owned"} onSearchParamsChange={onSearchParamsChange}/>
        },
        {
            key: 'AssignedTasks',
            label: 'Assigned to Me',
            children: <TaskTable session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} taskType={"assigned"} onSearchParamsChange={onSearchParamsChange}/>
        },
        {
            key: 'Followed',
            label: 'Followed',
            children: <TaskTable session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} taskType={"followed"} onSearchParamsChange={onSearchParamsChange}/>
        },
        {
            key: 'NewTask',
            label: 'New Task',
            children: <NewTask refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        }
    ];

    if (checkPerm(session, "allTask")) {
        items.push({
            key: 'AllTasks',
            label: 'All Tasks',
            children: <TaskTable session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} taskType={"all"}
                                 showVerified={true} onSearchParamsChange={onSearchParamsChange}/>
        })
    }

    const onTabChange = (key) => {
        const newSearchParams  = {...searchParams}// new URLSearchParams(searchParams);
        newSearchParams['tabKey'] = key;
        setSearchParams(newSearchParams);
    }

    const onClick = () => {
    }

    return <Tabs defaultActiveKey={defaultKey} tabPosition={'left'} items={items} onChange={onTabChange} onTabClick={onClick}/>
}